import { SelectField } from '@monorepo/shared/componentsV2/fields/SelectField';
import { SelectableOption } from '@monorepo/shared/types/SelectableOption';
import { isRequired } from '@monorepo/shared/utils/validators';
import { OPERATORS_WITHOUT_VALUE, Operator } from 'mapistry-shared';
import React, { useEffect } from 'react';
import { useForm } from 'react-final-form';
import { startOfDay } from 'date-fns';
import { DateValueField } from './DateValueField';

const dateOperatorOptions: SelectableOption<Operator>[] = [
  { label: 'Equals', value: Operator.EQUALS },
  { label: 'Is empty', value: Operator.EMPTY },
  { label: 'Is not empty', value: Operator.NOT_EMPTY },
  { label: 'Is not', value: Operator.NOT_EQUALS },
  { label: 'Is before', value: Operator.BEFORE },
  { label: 'Is equal or before', value: Operator.EQUAL_OR_BEFORE },
  { label: 'Is after', value: Operator.AFTER },
  { label: 'Is equal or after', value: Operator.EQUAL_OR_AFTER },
];

export function DateFilterCondition({
  name,
  operatorOptions = dateOperatorOptions,
}: {
  name: string;
  operatorOptions?: SelectableOption<Operator>[];
}) {
  const { change, batch, getFieldState } = useForm();
  const operatorFieldState = getFieldState(`${name}.operator`);
  const operator = operatorFieldState?.value;
  const hasNoValue = !!operator && OPERATORS_WITHOUT_VALUE.includes(operator);
  useEffect(() => {
    if (!operatorFieldState) return;
    const isUnsupportedOperator = !operatorOptions.some(
      (o) => o.value === operatorFieldState.value,
    );
    if (operatorFieldState.value == null || isUnsupportedOperator) {
      // Filter condition is new, default to 'is before today'
      batch(() => {
        change(`${name}.operator`, Operator.BEFORE);
        change(`${name}.value`, startOfDay(new Date()));
      });
    }
  }, [batch, change, name, operatorFieldState, operatorOptions]);
  useEffect(() => {
    if (hasNoValue) {
      change(`${name}.value`, null);
    }
  }, [change, name, hasNoValue]);

  return (
    <>
      <SelectField
        isLabelHidden
        label="Operator"
        name={`${name}.operator`}
        options={operatorOptions}
        placeholder="Operator"
        required
        validate={isRequired}
      />
      <DateValueField filterConditionName={name} />
    </>
  );
}
